/* there is an inner div in react-rte that reacts to mouse clicks and sends the focus. It has to be the one that
expands, not ones above it, otherwise there would be unclickable space in editor.
 */
.editor > div > div > div {
  min-height: 5em;
}

.largeEditor > div > div > div {
  min-height: 7em;
}

.container {
  border: 1px solid var(--darkSilver);
  border-radius: 0;
  font-size: 1rem;
  font-family: var(--baseFont) !important;
  outline: solid 2px transparent;
  margin-bottom: 1em;
}

.focus {
  outline-color: var(--blue);
  border-color: transparent;
}

.disabled {
  background-color: var(--lightSilver);
}
